// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Utilities from "@apollo/client/utilities";
import * as ApolloClient__Cache_InMemory_Policies_FieldPolicy from "../../cache/inmemory/ApolloClient__Cache_InMemory_Policies_FieldPolicy.bs.js";

var Js_ = {};

function concatPagination(keyArgs) {
  return Utilities.concatPagination(Caml_option.some(ApolloClient__Cache_InMemory_Policies_FieldPolicy.FieldPolicy_KeyArgs.toJs(keyArgs)));
}

function offsetLimitPagination(keyArgs) {
  return Utilities.offsetLimitPagination(Caml_option.some(ApolloClient__Cache_InMemory_Policies_FieldPolicy.FieldPolicy_KeyArgs.toJs(keyArgs)));
}

function relayStylePagination(keyArgs) {
  return Utilities.relayStylePagination(Caml_option.some(ApolloClient__Cache_InMemory_Policies_FieldPolicy.FieldPolicy_KeyArgs.toJs(keyArgs)));
}

var FieldPolicy;

var KeyArgs;

export {
  FieldPolicy ,
  KeyArgs ,
  Js_ ,
  concatPagination ,
  offsetLimitPagination ,
  relayStylePagination ,
}
/* @apollo/client/utilities Not a pure module */
